module.exports = __webpack_public_path__ + "img/paypal.afd4f836.svg";